import React from 'react';
import { Container, Typography, Grid, Tooltip, Zoom, Fade } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SkillCard, SkillImage } from '../styles/SkillsStyles';
import { useSkills } from '../utils/SkillsUtils';

const SkillsComp = () => {
  const theme = useTheme();
  const { skills } = useSkills();

  return (
    <Container maxWidth="lg" sx={{ py: 6 }} id="skills">
      <Typography variant="h3" gutterBottom align="center" sx={{ 
        mb: 4, 
        fontWeight: 'bold', 
        background: theme.palette.mode === 'dark'
          ? (theme.custom?.gradients?.brandTextDark || 'linear-gradient(135deg, #BB86FC 0%, #3700B3 50%, #03DAC6 100%)')
          : 'linear-gradient(135deg, #FF6B6B 0%, #6A5ACD 50%, #00CED1 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textShadow: '2px 2px 4px rgba(0,0,0,0.1)',
      }}>
        Habilidades Técnicas
      </Typography>
      <Grid container spacing={3}>
        {skills.map((skill, index) => (
          <Grid item xs={4} sm={3} md={2} lg={2} key={index}>
            <Fade in={true} timeout={500 + index * 100}>
              <Tooltip 
                title={`Experiência com ${skill.name}`} 
                TransitionComponent={Zoom} 
                arrow 
                placement="top"
              >
                <SkillCard elevation={0}>
                  <SkillImage src={skill.image} alt={skill.name} />
                  <Typography 
                    variant="caption" 
                    fontWeight="bold"
                    sx={{
                      background: theme.palette.mode === 'dark'
                        ? (theme.custom?.gradients?.brand || 'linear-gradient(45deg, #BB86FC 30%, #03DAC6 90%)')
                        : 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {skill.name}
                  </Typography>
                </SkillCard>
              </Tooltip>
            </Fade>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default SkillsComp;
